
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.885 46.097l-15.6-15.6 15.6-15.6c.6-.6.2-3.7-.7-2.7l-16.6 16.6-16.6-16.6c-.9-.9-1.3 2.1-.7 2.7l15.6 15.6-15.6 15.6c-.6.6-.2 3.7.7 2.7l16.6-16.6 16.6 16.6c1 .9 1.4-2.1.7-2.7z"}})])
          )
        }
      }
    